import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { PartAliasCell } from 'bom/elements';
import { IComponentTemplate } from 'elements/types';
import { PricingHelper } from 'pricing/helpers';

import { CostCell, PackagingCell, PartNumberCell } from './cells';
import { PartListColId } from './enums';

interface IColumnDefParams {
  onPartNumberClick: (part: IComponentTemplate) => void;
}

export const columnDef = ({ onPartNumberClick }: IColumnDefParams): ColDef[] => [
  {
    colId: PartListColId.PART,
    headerName: t('headerPartNumber'),
    field: 'part',
    filter: 'agTextColumnFilter',
    flex: 1,
    minWidth: 150,
    cellRenderer: PartNumberCell,
    cellRendererParams: { onPartNumberClick },
  },
  {
    colId: PartListColId.PART_DESCRIPTION,
    headerName: t('headerDescription'),
    field: 'partDescription',
    filter: 'agTextColumnFilter',
    flex: 2,
    minWidth: 200,
  },
  {
    colId: PartListColId.QUANTITY,
    headerName: t('headerQuantity'),
    field: 'quantity',
    filter: 'agNumberColumnFilter',
    cellStyle: { textAlign: 'right' },
    flex: 1,
    minWidth: 100,
    editable: true,
  },
  {
    colId: PartListColId.UOM,
    headerName: t('headerUom'),
    field: 'uom',
    filter: 'agSetColumnFilter',
    flex: 1,
    minWidth: 80,
    editable: true,
    cellEditorSelector: ({ data }) => ({
      component: 'agRichSelectCellEditor',
      params: {
        values: data?.allowedUoms,
      },
    }),
  },
  {
    colId: PartListColId.MANUFACTURER_NAME,
    headerName: t('headerManufacturer'),
    field: 'manufacturerName',
    filter: 'agTextColumnFilter',
    flex: 1,
    minWidth: 150,
  },
  {
    colId: PartListColId.ALIAS,
    headerName: t('headerAlias'),
    filter: 'agTextColumnFilter',
    valueGetter: ({ data }) =>
      [data?.partOrderingNumber, data?.partEngineeringNumber].filter(Boolean).join(' '),
    cellRenderer: PartAliasCell,
    flex: 1,
    minWidth: 150,
  },
  {
    colId: PartListColId.PACKAGING,
    headerName: t('headerPackaging'),
    field: 'packageUnits',
    filter: 'agNumberColumnFilter',
    sortable: false,
    cellRenderer: PackagingCell,
    flex: 1,
    minWidth: 120,
  },
  {
    colId: PartListColId.COMPUTED_COST,
    headerName: t('headerUnitCost'),
    field: 'computedCost',
    filter: 'agNumberColumnFilter',
    cellRenderer: CostCell,
    flex: 1,
    minWidth: 140,
  },
  {
    colId: PartListColId.EXTENDED_COMPUTED_COST,
    headerName: t('headerExtCost'),
    field: 'extendedComputedCost',
    filter: 'agNumberColumnFilter',
    valueFormatter: ({ value }) => PricingHelper.formatPricing({ amount: value }),
    flex: 1,
    minWidth: 120,
  },
];
